import czStorage from './czStorage'

const TokenKey = 'token'
const userIdKey = 'userId'
const usernameKey = 'username'

export function getToken() {
	return czStorage.get(TokenKey)
}

export function setToken(token) {
	return czStorage.set(TokenKey, token)
}

export function getUserId() {
	return czStorage.get(userIdKey)
}

export function setUserId(id) {
	return czStorage.set(userIdKey, id)
}

export function setUsername(username) {
	return czStorage.set(usernameKey, username)
}

export function removeToken() {
	return czStorage.remove(TokenKey)
}
